<div class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="onClose()">
  <div class="relative w-full max-w-4xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-[0_24px_70px_rgba(15,23,42,0.25)] border border-slate-100/60 dark:border-slate-700 overflow-hidden animate-fade-in-up" (click)="$event.stopPropagation()">
    <div class="absolute top-0 left-[10%] w-[80%] h-1.5 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300 rounded-b-full"></div>

    <div *ngIf="isLoading() || isSaving()" class="absolute inset-0 z-50 bg-white/70 dark:bg-slate-900/70 backdrop-blur-sm flex items-center justify-center">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="px-6 md:px-8 pt-8 pb-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <span class="w-11 h-11 rounded-2xl bg-amber-50 dark:bg-amber-900/20 text-amber-500 flex items-center justify-center">
          <span class="material-icons">local_parking</span>
        </span>
        <div>
          <h2 class="text-xl font-black text-slate-800 dark:text-slate-100">{{ isEdit ? 'แก้ไข Parking Site' : 'เพิ่ม Parking Site' }}</h2>
          <p class="text-xs text-slate-400 mt-0.5">กำหนดข้อมูลสาขา / ลานจอดรถ</p>
        </div>
      </div>
      <button (click)="onClose()" class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 md:p-8 space-y-6 max-h-[75vh] overflow-y-auto custom-scrollbar">
      <div *ngIf="isEdit" class="flex items-center gap-2 px-4 py-3 rounded-2xl bg-slate-50 dark:bg-slate-800 text-xs text-slate-500">
        <span class="material-icons text-amber-500 text-[18px]">info</span>
        <span>ID: <b class="text-slate-700 dark:text-slate-200">{{ formData.id }}</b></span>
        <span class="mx-1 text-slate-300">•</span>
        <span>สร้างเมื่อ {{ formData.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <section>
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">ข้อมูลหลัก</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">ชื่อ Site <span class="text-rose-500">*</span></label>
            <input [(ngModel)]="formData.name" placeholder="ชื่อสาขา / ลานจอด"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Key</label>
            <input [(ngModel)]="formData.key" placeholder="รหัส Site"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 font-mono" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Tax ID</label>
            <input [(ngModel)]="formData.taxId" placeholder="เลขประจำตัวผู้เสียภาษี"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 font-mono" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">ที่อยู่</label>
            <input [(ngModel)]="formData.address" placeholder="ที่อยู่สาขา"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Latitude</label>
            <input type="number" step="any" [(ngModel)]="formData.latitude" placeholder="13.7563"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 font-mono" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Longitude</label>
            <input type="number" step="any" [(ngModel)]="formData.longitude" placeholder="100.5018"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 font-mono" />
          </div>
        </div>
        <div *ngIf="googleMapsUrl" class="mt-3 flex justify-end">
          <button type="button" (click)="openGoogleMaps()"
            class="px-4 py-2 text-sm font-bold text-sky-600 hover:text-sky-700 bg-sky-50 hover:bg-sky-100 rounded-xl transition-all flex items-center gap-2 cursor-pointer">
            <span class="material-icons text-base">map</span> เปิดใน Google Maps
          </button>
        </div>
      </section>

      <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">เวลาเปิด–ปิด / สถานะ</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Open Time</label>
            <input [(ngModel)]="formData.openTime" placeholder="06:00"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Close Time</label>
            <input [(ngModel)]="formData.closeTime" placeholder="22:00"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
        <div class="mt-4 flex flex-wrap gap-5">
          <label class="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="formData.isOnline" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Is Online</span>
          </label>
          <label class="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="formData.open" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Open</span>
          </label>
        </div>
      </section>

      <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">บริการ / Taiwan</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Site EV</label>
            <input [(ngModel)]="formData.siteEv" placeholder="รหัส / ชื่อ Site EV"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 mb-2">Site Parking</label>
            <input [(ngModel)]="formData.siteParking" placeholder="รหัส Site Parking"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-500 mb-2">Taiwan URL</label>
            <input [(ngModel)]="formData.taiwanUrl" placeholder="https://..."
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200" />
          </div>
        </div>
        <div class="mt-4 flex flex-wrap gap-5">
          <label class="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="formData.parking" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Parking</span>
          </label>
          <label class="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="formData.ev" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">EV</span>
          </label>
          <label class="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="formData.monthly" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Monthly</span>
          </label>
          <label class="inline-flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="formData.taiwanSite" class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-200">Taiwan Site</span>
          </label>
        </div>
      </section>

      <section class="border-t border-slate-100 dark:border-slate-800 pt-5">
        <h3 class="mb-3 text-xs font-black uppercase tracking-wider text-amber-500">Logo (Base64)</h3>
        <div class="flex flex-col sm:flex-row gap-4 items-start">
          <div class="w-24 h-24 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 overflow-hidden flex items-center justify-center shrink-0">
            <img *ngIf="logoPreviewSrc" [src]="logoPreviewSrc" alt="logo" class="w-full h-full object-contain" />
            <span *ngIf="!logoPreviewSrc" class="material-icons text-slate-300 text-3xl">image</span>
          </div>
          <div class="flex-1 space-y-3 w-full">
            <input type="file" accept="image/*" (change)="onLogoFileChange($event)"
              class="block w-full text-xs text-slate-500 file:mr-3 file:py-2 file:px-4 file:rounded-xl file:border-0 file:font-bold file:bg-amber-50 file:text-amber-600 hover:file:bg-amber-100 cursor-pointer" />
            <textarea [(ngModel)]="formData.logoBase64" rows="3" placeholder="วาง Base64 หรืออัปโหลดรูปด้านบน"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 outline-none focus:ring-2 focus:ring-amber-200 resize-none font-mono text-[11px]"></textarea>
            <button *ngIf="formData.logoBase64" type="button" (click)="clearLogo()"
              class="text-xs font-bold text-rose-500 hover:text-rose-600 cursor-pointer">ลบ Logo</button>
          </div>
        </div>
      </section>

      <div *ngIf="isEdit" class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-800/40 p-4">
        <div class="font-bold text-[10px] text-slate-400 uppercase tracking-widest mb-3">ข้อมูลตรวจสอบ Odoo</div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs text-slate-500">
          <div>create_uid: <b>{{ formData.createUid ?? '—' }}</b></div>
          <div>write_uid: <b>{{ formData.writeUid ?? '—' }}</b></div>
          <div>create_date: <b>{{ formData.createDate | date:'dd/MM/yyyy HH:mm' }}</b></div>
          <div>write_date: <b>{{ formData.writeDate | date:'dd/MM/yyyy HH:mm' }}</b></div>
        </div>
      </div>
    </div>

    <div class="px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col-reverse sm:flex-row justify-between gap-3 bg-slate-50/50 dark:bg-slate-900/50">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
      <button (click)="onClose()" class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:bg-white dark:hover:bg-slate-800 transition-all cursor-pointer">ยกเลิก</button>
      <button (click)="onSave()" [disabled]="isSaving()"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none disabled:opacity-50 transition-all cursor-pointer flex items-center justify-center gap-2">
        <span class="material-icons text-[18px]">save</span>{{ isSaving() ? 'กำลังบันทึก...' : 'บันทึกข้อมูล' }}
      </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.ParkingSite"
  [entityId]="itemId"
  title="ประวัติลานจอด"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
